// =======================================================
// Variables
// =======================================================

// Const Global
const body              = document.body;
const menu              = document.querySelector('#js-NavMain');
const menuItems         = document.querySelectorAll('#js-NavMain .menu-item-has-children.menu__item');
const menuLinks         = document.querySelectorAll('#js-NavMain .menu-item-has-children .menu__link');

// Const Simple Menu
const menuSimple        = menu.classList.contains('nav-main--simple');
const menuOpen          = document.querySelector('#js-OpenMenu');
const menuClose         = document.querySelector('#js-CloseMenu');
const subMenuCloses     = document.querySelectorAll('.nav-main .submenu__close');

/* const menuCloseBis      = document.querySelectorAll('.js-close-menu'); */


// Const Burger Menu
/* const menuBurger        = menu.classList.contains('nav-main--burger');
const menuOpenBurger    = document.querySelector('#js-OpenMenu');
const menuCloseBurger   = document.querySelector('#js-CloseMenu');
const menuCloseA11y     = document.querySelector('#js-CloseMenuA11y');
const subMenuClose      = document.querySelector('#js-CloseSubmenu');
const buttonscontainer  = document.querySelector('.nav-main-buttons'); */


// =======================================================
// Simple responsive Menu
// =======================================================
// Check if condition
// console.log('If classlist contains nav-main--simple');

// ---------------------------------------------------
// Open/Close submenu
// ---------------------------------------------------
menuLinks.forEach(function (menuLink) {

    function OpenCloseSubmenu(menuLink) {

        // Variables
        let menuLinkParent = menuLink.parentElement;
        let menuLinkParentOpen = menuLinkParent.classList.contains('js-open-submenu');

        menuItems.forEach(function (menuItem) {

            // Variables
            let menuItemOpen  = menuItem.classList.contains('js-open-submenu');
            let submenuLinks    = menuItem.querySelectorAll('.submenu__link');

            // If submenu open : Remove js-open-submenu
            if (menuItemOpen) {

                // Close submenu
                menuItem.classList.remove('js-open-submenu');
                menu.classList.remove('js-open-submenu');

                // Check class removed
                // console.log("remove open menu");

                submenuLinks.forEach(function (submenuLink) {
                    submenuLink.setAttribute('tabindex', -1);
                    // console.log("tabindex-1");
                });
            }

        });

        // If submenu close : Add js-open-submenu
        if (!menuLinkParentOpen) {

            // Open submenu
            menuLinkParent.classList.add('js-open-submenu');
            menu.classList.add('js-open-submenu');

            // Check class added
            // console.log("add open menu");

            menuItems.forEach(function (menuItem) {
                let menuItemOpen = menuItem.classList.contains('js-open-submenu');
                
                if (menuItemOpen) {
                    let submenuLinks = menuItem.querySelectorAll('.submenu__link');
                    submenuLinks.forEach(function (submenuLink) {
                        submenuLink.setAttribute('tabindex', 0);
                        // console.log("tabindex-0");
                    });
                }

            });
        }

    }

    // Event click
    menuLink.addEventListener('click', (e) => {
        OpenCloseSubmenu(menuLink);

        e.preventDefault();
        // console.log("e.preventdefault");
    });


    function CloseSubmenu(menuLink) {
        menuItems.forEach(function (menuItem) {

            // Variables
            let menuItemOpen = menuItem.classList.contains('js-open-submenu');
            let submenuLinks = menuItem.querySelectorAll('.submenu__link');

            // If submenu open : Remove js-open-submenu
            if (menuItemOpen) {

                // Close submenu
                menuItem.classList.remove('js-open-submenu');
                menu.classList.remove('js-open-submenu');

                submenuLinks.forEach(function (submenuLink) {
                    submenuLink.setAttribute('tabindex', -1);
                    // console.log("tabindex-1");
                });

                // Check class removed
                // console.log("remove open menu");
            }

        });
    }
    
    document.addEventListener("mouseup", function(event) {
        if (!menu.contains(event.target)) {
            CloseSubmenu(menuLink);
        }
    });

});

// ---------------------------------------------------
// submenu close
// ---------------------------------------------------
let ClosesSubmenuBis = document.querySelectorAll('.submenu__title');
ClosesSubmenuBis.forEach(function (CloseSubmenuBis) {
    CloseSubmenuBis.addEventListener('click', function () {
        this.closest('.menu__item').classList.remove('js-open-submenu');
    });
});

subMenuCloses.forEach(function (subMenuClose) {
    subMenuClose.addEventListener('click', function () {
        this.closest('.menu__item').classList.remove('js-open-submenu');

        // Check deleted class
        // console.log("Remove js-open-submenu");
    });
});


// ---------------------------------------------------
// Responsive menu
// ---------------------------------------------------
// Open menu

menuOpen.addEventListener('click', function () {
    menu.classList.toggle('js-open-menu');
    body.classList.toggle('js-open-menu');
}); 


// Close menu
menuClose.addEventListener('click', function () {
    menu.classList.remove('js-open-menu');
    body.classList.remove('js-open-menu');
}); 


// =======================================================
// Menu text separation MOCHE
// =======================================================
let menuEntry = document.getElementsByClassName('menu__link');
let firstEntry = menuEntry[0].innerHTML;
let secondEntry = menuEntry[1].innerHTML;
let thirdEntry = menuEntry[2].innerHTML;
let fourthEntry = menuEntry[3].innerHTML;

const firstArray = firstEntry.split(" ");
const secondArray = secondEntry.split(" ");
const thirdArray = thirdEntry.split(" ");
const fourthArray = fourthEntry.split(" ");

let firstFilter= firstArray.filter(Boolean);
let secondFilter= secondArray.filter(Boolean);
let thirdFilter= thirdArray.filter(Boolean);
let fourthFilter= fourthArray.filter(Boolean);

menuEntry[0].innerHTML = '<span>' + firstFilter[1] + " " + firstFilter[2] + '</span>' + " " + firstFilter[3] + " " + firstFilter[4] + " " + firstFilter[5];
menuEntry[1].innerHTML = '<span>' + secondFilter[1] + '</span>' + " " + secondFilter[2] + " " + secondFilter[3];
menuEntry[2].innerHTML = '<span>' + thirdFilter[1] + " " + thirdFilter[2] +  " " + '</span>' + thirdFilter[3] + " " + thirdFilter[4];
menuEntry[3].innerHTML = '<span>' + fourthFilter[1] + '</span>' + " " + fourthFilter[2];
